import baseURL from "../config";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Tooltip,
  useTheme,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../Components/Header";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { tokens } from "../theme";
import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import { getDecryptedToken } from "../auth";

const BannerForm = () => {
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const token = getDecryptedToken();
  const [imageData, setImageData] = useState("");

  const handleFileUpload = (file, setFieldValue) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const image = reader.result.split(",")[1];
      setImageData(image);
      setFieldValue("Image", image);
    };
    reader.readAsDataURL(file);
  };

  const handleFormSubmit = async (values, actions) => {
    try {
      await axios.post(
        `${baseURL}/api/Banner/AddNewBanner`,
        {
          bannerId: 0,
          image: imageData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Banner u shtua me sukses!");
      navigate("/banners");
    } catch (error) {
      toast.error(error.response?.data?.message || "Banner nuk u shtua!");
      actions.setSubmitting(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer hideProgressBar={true} autoClose={2000} />
      <Header title="Shto Banner" subtitle="Plotesoni te dhenat per banner" />
      <Link to="/banners" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
        >
          <KeyboardReturnOutlinedIcon />
          Tabela e Banners
        </Button>
      </Link>

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <Box display="flex" alignItems="center" sx={{ gridColumn: "span 2" }}>
                <TextField
                  type="file"
                  onChange={(e) => handleFileUpload(e.target.files[0], setFieldValue)}
                  fullWidth
                  margin="dense"
                  error={!!touched.Image && !!errors.Image}
                  helperText={touched.Image && errors.Image}
                  inputProps={{
                    accept: "image/*",
                  }}
                />
                <Tooltip title="Image should be 771x170 for the best quality" arrow>
                  <IconButton>
                    <InfoOutlinedIcon sx={{ color: colors.primary[900] }} />
                  </IconButton>
                </Tooltip>
              </Box>

              <Box sx={{ gridColumn: "span 4" }}>
                <hr
                  style={{
                    border: "none",
                    height: "2px",
                    backgroundColor: "white",
                    margin: "0",
                    padding: "0",
                  }}
                />
              </Box>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                disabled={isSubmitting}
                style={{ backgroundColor: colors.primary[700] }}
                variant="contained"
              >
                Shto Banner
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  Image: yup.string().required("Image is required!"),
});

const initialValues = {
  Image: "",
};

export default BannerForm;
